<template>
  <div class="water-event-container" v-if="visible">
    <div class="water-event-header">
      <span class="header-title">停水事件</span>
      <a-icon type="close" class="close-icon" @click="handleClose" />
    </div>

    <div class="event-list" v-if="eventList.length > 0">
      <div class="event-item" v-for="item in eventList" :key="item.id" @click="handleEventClick(item)">
        <a-row>
          <a-col :span="12">
            <a-tooltip>
              <template slot="title">{{ item.eventName }}</template>
              <h2>{{ item.eventName }}</h2>
            </a-tooltip>
            <a-tooltip>
              <template slot="title">{{ item.describe }}</template>
              <p>{{ item.describe }}</p>
            </a-tooltip>
          </a-col>
          <a-col :span="12">
            <h3>{{ item.createTime }}</h3>
          </a-col>
        </a-row>
      </div>
    </div>

    <a-empty v-else description="暂无停水事件" />

    <div class="pagination" v-if="total > 1">
      <a-button @click="handlePrevPage" :disabled="page === 1">上一页</a-button>
      <span class="page-info">{{ page }}/{{ total }}</span>
      <a-button @click="handleNextPage" :disabled="page === total">下一页</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaterEvent',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      queryUrl: '/pipe-network/gis_water_events/page',
      pipeLineQueryUrl: '/pipe-network/gis/pipe-lines',
      eventList: [],
      page: 1,
      limit: 10,
      total: 0,
      loading: false
    }
  },
  watch: {
    visible: {
      handler (newVal) {
        if (newVal) {
          this.page = 1;
          this.loadEventList();
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClose () {
      this.$emit('close');
    },

    // 加载停水事件列表
    async loadEventList () {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          limit: this.limit,
          status: 0
        };

        const response = await this.$http.get(this.queryUrl, { params });

        if (response && response.data) {
          this.eventList = response.data.list || [];
          this.total = Math.ceil((response.data.total || 0) / this.limit);
          console.log('停水事件列表加载成功:', this.eventList);
        } else {
          this.eventList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('加载停水事件列表失败:', error);
        this.$message?.error('加载停水事件列表失败');
        this.eventList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 点击事件项
    async handleEventClick (item) {
      console.log('点击停水事件:', item);
      try {
        if (!item || !item.lineId) {
          this.$message?.warning('该停水事件缺少 lineId');
          this.$emit('event-click', item, null);
          return;
        }
        const response = await this.$http.get(`${this.pipeLineQueryUrl}/${item.lineId}`);
        // 兼容两种返回结构：{ code, data } 或直接 data 对象
        const lineDetail = response && response.data
          ? (response.data.data || response.data)
          : null;
        this.$emit('event-click', item, lineDetail);
      } catch (error) {
        console.error('根据事件查询管线失败:', error);
        this.$message?.error('查询关联管线失败');
        this.$emit('event-click', item, null);
      }
    },

    // 上一页
    handlePrevPage () {
      if (this.page > 1) {
        this.page--;
        this.loadEventList();
      }
    },

    // 下一页
    handleNextPage () {
      if (this.page < this.total) {
        this.page++;
        this.loadEventList();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.water-event-container {
  position: fixed;
  left: 20px;
  top: 80px;
  width: 400px;
  max-height: calc(100vh - 200px);
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.water-event-header {
  background-image: linear-gradient(270deg, rgba(7, 142, 231, 0.959) 0%, #0890f2 100%);
  border-radius: 6px 6px 0 0;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;

  .header-title {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
  }

  .close-icon {
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 4px;
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: rotate(90deg);
    }
  }
}

.event-list {
  height: 23.25rem;
  overflow-y: auto;
  padding: 12px;

  // 自定义滚动条
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.3);
    }
  }

  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }
}

.event-item {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(5px);
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(8, 144, 242, 0.2);
    border-color: rgba(8, 144, 242, 0.5);
    box-shadow: 0 4px 16px rgba(8, 144, 242, 0.3);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  h2 {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  h3 {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 0;
    text-align: right;
    font-weight: 500;
  }
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);

  .page-info {
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    min-width: 50px;
    text-align: center;
  }

  button {
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}

:deep(.ant-empty) {
  padding: 60px 20px;

  .ant-empty-description {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
  }

  .ant-empty-image svg {
    opacity: 0.5;
  }
}
</style>
